import {useContract} from "./useContract";
import {ABI_LAUNCHPAD_POOL} from "../utils/abis";
import {useCallback} from "react";
import {DialogType, useDialog} from "../context/DialogContext";

export default function useHandleRebase(poolAddress?: string|null) {
    const contract = useContract(poolAddress, ABI_LAUNCHPAD_POOL)
    const {open} = useDialog()
    const handleRebase = useCallback(async () => {
        if (contract) {
            try {
                open(DialogType.Waiting, {title: 'Waiting for confirm rebase.'})
                const operation = await contract.rebaseShare()
                open(DialogType.Waiting, {title: 'Waiting for confirmation.'})
                await operation.wait()
                open(DialogType.Success, {title: 'Rebase Success!'})
                return true
            } catch (e: any) {
                console.log('error', e)
                open(DialogType.Error, {title: 'Rebase error!', desc: e.message|| e.data.message})
                return false
            }
        }
    }, [contract, open])
    return handleRebase
}